<template>
  <div>
    <div>
      <Titulo :titulo="'Informes - ' + routeName" />
    </div>
    <!-- coger el parametro que se envio por la ruta -->
    <!-- {{$route.params.id}} -->
    <div class="margin-informes">
      <p class="mb-5 text-justify">
        Ingresar número de código y rango de fecha del cargue o registro de la
        información a consultar, con el fin de validar y confirmar el proyecto
        de facturación.
      </p>
      <b-modal
        id="modal-1"
        title="Formato de descarga"
        hide-footer
        centered
        size="lg"
      >
        <div class="m-1">
          <div class>
            <div class="container">
              <b-row>
                <div class="col text-center" v-if="loading_export">
                  Por favor espere mientras exportamos los datos...
                  <img src="@/assets/images/loader.gif" alt /></div
              ></b-row>
              <b-row v-if="!loading_export">
                <b-col sm="6" class="text-center">
                  <b-button
                    variant="outline-info"
                    block
                    @click="exportarPrefactura"
                    :disabled="loading_export"
                  >
                    <i class="fa fa-check"></i> Descargar en formato XLSX
                  </b-button>
                </b-col>
                <b-col sm="6" class="text-center">
                  <b-button
                    variant="outline-info"
                    block
                    @click="exportarPrefacturaCSV"
                    :disabled="loading_export"
                  >
                    <i class="fa fa-check"></i> Descargar en formato CSV
                  </b-button>
                </b-col>
              </b-row>
              &nbsp;
            </div>
          </div>
        </div>
      </b-modal>
      <!--
        @props
            data: Array,            required: true
            pagination: boolean,    required: false
            perPage: Number,        required: false
            SetectFiltro: Array     required: false
            filtro: boolean         required: false
      -->

      <table-component
        :data="dataGarantia"
        :SetectFiltro="convenios"
        @click-buscar="buscar"
        @click-event="clickEvent"
        :perPage="perPage"
        @checkbox="checkboxGarantia"
        filtro
        showFilterConvenios
        :Convenios="convenios"
        showFilterDates
        :dataLength="dataLength"
        :pagination="false"
        :showMessage="true"
        :message="'Prefactura Garantías'"
      >
        <table-column
          slot="label"
          :label="'Seleccione'"
          v-bind:value="'checkbox:nombre_archivo'"
          style="max-width: 10px"
          customClass="text-center"
        ></table-column>
        <table-column
          slot="label"
          :label="'Modelo'"
          v-bind:value="'modelo'"
          customClass="text-center"
        ></table-column>
        <table-column
          slot="label"
          :label="'Archivo de Cargue'"
          v-bind:value="'nombre_archivo'"
          customClass="text-center"
        ></table-column>
        <table-column
          slot="label"
          :label="'Producto'"
          v-bind:value="'producto'"
          customClass="text-center"
        ></table-column>
        <table-column
          slot="label"
          :label="'Cantidad de Registros'"
          v-bind:value="'cantidad_registros'"
          customClass="text-center"
        ></table-column>
        <table-column
          slot="label"
          :label="'Fecha Cargue'"
          v-bind:value="'fecha_aplicacion'"
          customClass="text-center"
        ></table-column>
        <table-column
          slot="label"
          :label="'Estado'"
          v-bind:value="'aprobado'"
          customClass="text-center"
        ></table-column>
      </table-component>

      <!--h1>Test divisor prefactura cartera</h1-->

      <table-component
        :data="dataCartera"
        :showMessage="true"
        :message="'Prefactura Cartera'"
        @checkbox="checkboxCartera"
      >
        <table-column
          slot="label"
          :label="'Seleccione'"
          v-bind:value="'checkbox:nombre_archivo'"
          style="max-width: 10px"
        ></table-column>
        <table-column
          slot="label"
          :label="'Modelo'"
          v-bind:value="'modelo'"
          customClass="text-center"
        ></table-column>
        <table-column
          slot="label"
          :label="'Archivo de Cargue'"
          v-bind:value="'nombre_archivo'"
          customClass="text-center"
        ></table-column>
        <table-column
          slot="label"
          :label="'Producto'"
          v-bind:value="'producto'"
          customClass="text-center"
        ></table-column>
        <table-column
          slot="label"
          :label="'Cantidad de Registros'"
          v-bind:value="'cantidad_registros'"
          customClass="text-center"
        ></table-column>
        <table-column
          slot="label"
          :label="'Fecha Cargue'"
          v-bind:value="'fecha_aplicacion'"
          customClass="text-center"
        ></table-column>
        <table-column
          slot="label"
          :label="'Estado'"
          v-bind:value="'aprobado'"
          customClass="text-center"
        ></table-column>
      </table-component>

      <table-component
        :data="dataUtilizacion"
        :showMessage="true"
        :message="'Prefactura Utilizaciones'"
        @checkbox="checkboxUtilizacion"
      >
        <table-column
          slot="label"
          :label="'Seleccione'"
          v-bind:value="'checkbox:nombre_archivo'"
          style="max-width: 10px"
        ></table-column>
        <table-column
          slot="label"
          :label="'Modelo'"
          v-bind:value="'modelo'"
          customClass="text-center"
        ></table-column>
        <table-column
          slot="label"
          :label="'Archivo de Cargue'"
          v-bind:value="'nombre_archivo'"
          customClass="text-center"
        ></table-column>
        <table-column
          slot="label"
          :label="'Producto'"
          v-bind:value="'producto'"
          customClass="text-center"
        ></table-column>
        <table-column
          slot="label"
          :label="'Cantidad de Registros'"
          v-bind:value="'cantidad_registros'"
          customClass="text-center"
        ></table-column>
        <table-column
          slot="label"
          :label="'Fecha Cargue'"
          v-bind:value="'fecha_aplicacion'"
          customClass="text-center"
        ></table-column>
        <table-column
          slot="label"
          :label="'Estado'"
          v-bind:value="'aprobado'"
          customClass="text-center"
        ></table-column>
      </table-component>

      <b-row>
        <b-col sm="6" class="text-left">
          <b-button
            variant="outline-info"
            :disabled="ItemsSelected.length == 0 || loading"
            block
            @click="descargarDatos"
          >
            <i class="fa fa-cloud-download"></i> Exportar Prefactura
          </b-button>
        </b-col>
        <b-col sm="6" class="text-right">
          <b-button
            variant="outline-success"
            :disabled="ItemsSelected.length == 0 || loading"
            block
            @click="aprobarFacturacion"
          >
            <i class="fa fa-check"></i> Aprobar proyecto de facturación
          </b-button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import XLSX from "xlsx";
import { saveAs } from "file-saver";

export default {
  name: "SubirInformes",
  data() {
    return {
      fecha_inicio: this.$moment().startOf("month").format("YYYY-MM-DD"),
      fecha_fin: this.$moment().format("YYYY-MM-DD"),
      convenio: null,
      perPage: 10,
      ItemsSelected: [],
      loading_export: false,
      dataGarantia: [],
      dataCartera: [],
      dataUtilizacion: [],
      itemsGarantia: [],
      itemsCartera: [],
      itemsUtilizacion: [],
    };
  },
  components: {
    Titulo: () => import("@/containers/layout/Titulo.vue"),
    TableComponent: () => import("@/components/table/TableComponent"),
    TableColumn: () => import("@/components/table/TableColumn"),
  },
  computed: {
    ...mapGetters({
      TablaVerProducto: "pages/TablaVerProducto",
      loading: "loading",
    }),
    convenios() {
      let data = this.$store.getters["pages/convenios"].map((convenio) => {
        return { value: convenio.id, text: convenio.nombre_convenio };
      });
      data.unshift({ value: null, text: "código", disabled: true });
      return data;
    },
    dataLength() {
      if (
        this.$store.getters["pages/dataInformes"].paginacion.total === undefined
      ) {
        return 0;
      } else {
        return this.$store.getters["pages/dataInformes"].paginacion.total;
      }
    },
    loading() {
      return this.$store.getters.loading;
    },
    data() {
      return this.$store.getters["pages/dataInformes"].datos;
    },
    routeName() {
      return this.$router.currentRoute.name;
    },
  },
  methods: {
    clickEvent(params, slug) {
      switch (slug) {
        case "paginacion":
          this.perPage = params.nRows;
          this.index(params.page);
          break;
      }
    },
    async aprobarFacturacion() {
      if (
        confirm(
          "Asegúrese de haber realizado revisión de prefactura antes de aprobar.  ¿Desea continuar con la aprobación?"
        )
      ) {
        this.$store.commit("SET_LOADING", true);
        try {
          let response = await this.$store.state.api.post(
            "informes/prefactura/almacenar",
            { archivos: this.ItemsSelected }
          );
          this.$toasted.success(response.data, {
            theme: "toasted-primary",
            position: "top-right",
            duration: 10000,
          });
          this.index();
        } catch (err) {
          this.$toasted.error(
            "Ocurrió un error al intentar procesar su solicitud.",
            {
              theme: "toasted-primary",
              position: "top-right",
              duration: 10000,
            }
          );
        }
        this.$store.commit("SET_LOADING", false);
      }
    },
    descargarDatos() {
      this.$root.$emit("bv::show::modal", "modal-1", "#btnShow");
    },
    async exportarPrefactura() {
      this.loading_export = true;
      this.$store.commit("SET_LOADING", true);
      try {
        let response = await this.$store.state.api.get("informes/prefactura", {
          params: { archivos: this.ItemsSelected },
        });

        if (response.data.paginacion.total > 0) {
          let data = XLSX.utils.json_to_sheet(response.data.datos, {
            header: [
              "numero_garantia",
              "modelo",
              "cliente",
              "cedula",
              "pagare",
              "referencia_credito",
              "convenio",
              "valor_credito",
              "varlor_cupo",
              "saldo_ultimo_mes",
              "plazo",
              "fecha_corte",
              "fecha_desembolso",
              "fecha_vencimiento",
              "producto_alias",
              "producto",
              "ecuacion_fianza",
              "modalidad",
              "valor_servicio_fianza",
              "iva",
              "total",
            ],
          });

          data["A1"].v = "Id";
          data["B1"].v = "Modelo";
          data["C1"].v = "Cliente";
          data["D1"].v = "Cedula";
          data["E1"].v = "Pagare";
          data["F1"].v = "Referencia credito";
          data["G1"].v = "Código";
          data["H1"].v = "Valor credito";
          data["I1"].v = "Valor cupo";
          data["J1"].v = "Saldo ultimo mes";
          data["K1"].v = "Plazo";
          data["L1"].v = "Fecha corte";
          data["M1"].v = "Fecha desembolso";
          data["N1"].v = "Fecha vencimiento";
          data["O1"].v = "Alias";
          data["P1"].v = "Producto";
          data["Q1"].v = "Ecuación";
          data["R1"].v = "Modalidad";
          data["S1"].v = "Valor Facturado";
          data["T1"].v = "Iva";
          data["U1"].v = "Total";

          var workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, data, "Prefactura");
          var wopts = { bookType: "xlsx", bookSST: false, type: "array" };
          var wbout = XLSX.write(workbook, wopts);

          var today = new Date();
          var dd = String(today.getDate()).padStart(2, "0");
          var mm = String(today.getMonth() + 1).padStart(2, "0");
          var yyyy = today.getFullYear();

          today = yyyy + "_" + mm + "_" + dd;

          saveAs(
            new Blob([wbout], { type: "application/octet-stream" }),
            "prefactura_" + today + ".xlsx"
          );
        } else {
          this.$toasted.error("No se encontraron datos para exportar.", {
            theme: "toasted-primary",
            position: "top-right",
            duration: 10000,
          });
        }
        this.$root.$emit("bv::hide::modal", "modal-1", "#btnShow");
      } catch (err) {
        this.$toasted.error(
          "Ocurrió un error al intentar procesar su solicitud.",
          {
            theme: "toasted-primary",
            position: "top-right",
            duration: 10000,
          }
        );
      }
      this.$store.commit("SET_LOADING", false);
      this.loading_export = false;
    },
    async exportarPrefacturaCSV() {
      this.loading_export = true;
      this.$store.commit("SET_LOADING", true);
      try {
        let response = await this.$store.state.api.get("informes/prefactura", {
          params: { archivos: this.ItemsSelected },
        });
        // let csvContent = Object.keys(response.data.datos[0]).join(";");
        let csvContent =
          "id;cliente;cedula;pagare;referencia_credito;codigo;valor_credito;valor_cupo;saldo_ultimo_mes;plazo;fecha_corte;fecha_desembolso;fecha_vencimiento;alias;producto;ecuacion;modalidad;Valor Facturado;iva;total;modelo";
        csvContent = csvContent + "\n";

        if (response.data.paginacion.total > 0) {
          response.data.datos.forEach((element) => {
            let row = Object.values(element).join(";");
            csvContent += row + "\r\n";
          });

          var today = new Date();
          var dd = String(today.getDate()).padStart(2, "0");
          var mm = String(today.getMonth() + 1).padStart(2, "0");
          var yyyy = today.getFullYear();

          today = yyyy + "_" + mm + "_" + dd;

          saveAs(
            new Blob([csvContent], { type: "text/csv" }),
            "prefactura_" + today + ".csv"
          );
        } else {
          this.$toasted.error("No se encontraron datos para exportar.", {
            theme: "toasted-primary",
            position: "top-right",
            duration: 10000,
          });
        }
        this.$root.$emit("bv::hide::modal", "modal-1", "#btnShow");
      } catch (err) {
        this.$toasted.error(
          "Ocurrió un error al intentar procesar su solicitud.",
          {
            theme: "toasted-primary",
            position: "top-right",
            duration: 10000,
          }
        );
      }
      this.loading_export = false;
      this.$store.commit("SET_LOADING", false);
    },
    async index(page = 1, paginar = false) {
      this.$store.dispatch("pages/fetch", {
        endpoint: "informes/prefactura/inicio",
        params: {
          fecha_inicio: this.fecha_inicio,
          fecha_fin: this.fecha_fin,
          convenio: this.convenio,
          row: this.perPage,
          page: page,
          paginar: paginar,
        },
      });
    },
    buscar(params) {
      this.fecha_inicio = params.fecha_inicio;
      this.fecha_fin = params.fecha_fin;
      this.convenio = params.convenio;
      this.perPage = params.nRows;
      this.index();
    },
    checkboxGarantia(params) {
      this.itemsGarantia = params;
      this.loadItemsSelected();
    },
    checkboxCartera(params) {
      this.itemsCartera = params;
      this.loadItemsSelected();
    },
    checkboxUtilizacion(params) {
      this.itemsUtilizacion = params;
      this.loadItemsSelected();
    },
    loadItemsSelected() {
      this.ItemsSelected = [];
      this.ItemsSelected = this.ItemsSelected.concat(this.itemsGarantia);
      this.ItemsSelected = this.ItemsSelected.concat(this.itemsCartera);
      this.ItemsSelected = this.ItemsSelected.concat(this.itemsUtilizacion);
    },
    loadDataGarantia(datos) {
      try {
        let values = [];
        let aceptados = [
          "garantias",
          "novaciones_plazo",
          "ajuste_garantia",
          "novaciones_saldo",
          "ajuste_general",
          "reestructuraciones",
        ];
        let eventos = [];

        datos.forEach((element) => {
          eventos = element.evento_calculo_fianza_id.split(",");
          eventos.forEach((value) => {
            if (aceptados.includes(value)) {
              values.push(element);
            }
          });
        });

        this.dataGarantia = values;
      } catch (err) {
        console.log(err);
      }
    },
    loadDataCartera(datos) {
      try {
        let values = [];
        let aceptados = ["cartera", "ajuste_cartera", "recaudos"];
        let eventos = [];

        datos.forEach((element) => {
          eventos = element.evento_calculo_fianza_id.split(",");
          eventos.forEach((value) => {
            if (aceptados.includes(value)) {
              values.push(element);
            }
          });
        });

        this.dataCartera = values;
      } catch (err) {
        console.log(err);
      }
    },
    loadDatosUtilizacion(datos) {
      try {
        let values = [];
        let aceptados = ["utilizaciones", "ajuste_utilizacion"];
        let eventos = [];

        datos.forEach((element) => {
          eventos = element.evento_calculo_fianza_id.split(",");
          eventos.forEach((value) => {
            if (aceptados.includes(value)) {
              values.push(element);
            }
          });
        });

        this.dataUtilizacion = values;
      } catch (err) {
        console.log(err);
      }
    },
  },
  watch: {
    data(newVal) {
      this.loadDataGarantia(newVal);
      this.loadDataCartera(newVal);
      this.loadDatosUtilizacion(newVal);
    },
  },
  mounted() {
    if (this.$store.getters["pages/convenios"].length < 1) {
      this.$store.dispatch("pages/fetchConvenios", {
        endpoint: "informes/convenio",
      });
    }

    setTimeout(() => {
      this.index();
    }, 1000);
  },
};
</script>
<style>
.margin-informes .table-responsive {
  min-height: 15vh !important;
}
</style>
